import clsx from "clsx";
import { UploadInputProps } from "../UploadInput/UploadInput.types";
import { UploadButtonRoot } from "./UploadButton.styles";
import { UploadButtonProps } from "./UploadButton.types";
import UploadButtonDisplay from "./UploadButtonDisplay/UploadButtonDisplay";

const UploadButton = ({
    //Upload props
    fileTypes = "image",
    readonly,
    name,
    multiple,
    onError,
    onFileUploaded,
    onUploadEnd,
    onUploadStart,
    onSuccess,
    disabled,
    upload,
    showLoading = false,
    //Button props
    style,
    isLoading,
    className,
    fullWidth,
    ...rest
}: UploadButtonProps) => {
    const uploadProps: Partial<UploadInputProps> = {
        fileTypes,
        readonly,
        name,
        multiple,
        onError,
        onFileUploaded,
        onUploadEnd,
        onUploadStart,
        onSuccess,
        disabled,
        upload,
        isLoading,
    };

    return (
        <UploadButtonRoot {...uploadProps} className={clsx("upload-btn", className, fullWidth && "full-width")} style={style}>
            {({ isLoading, isEditable }) => (
                <UploadButtonDisplay
                    {...rest}
                    type="button"
                    loading={showLoading && isLoading}
                    disabled={!isEditable}
                    fullWidth={fullWidth}
                />
            )}
        </UploadButtonRoot>
    );
};

export default UploadButton;
